package gr.tech.GRAttestation.models.pdf

import gr.tech.GRAttestation.models.attestation.SalesData

data class ItemTracker(
    val salesData: SalesData,
    var remaining: Int,
)
